module.exports = __webpack_public_path__ + "static/media/betting-guy.5fffa15a.jpg";